import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmrutiComponent } from './smruti.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AccordionModule } from '../accordion/accordion.module';


@NgModule({
  declarations: [
    SmrutiComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    AccordionModule
  ]
})
export class SmrutiModule { }
